import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { CreateSystemTagModalComponent } from './create-system-tag-modal/create-system-tag-modal.component';
import { ImportTagsModalComponent } from './import-tags-modal/import-tags-modal.component';
import { InactiveTagsModalComponent } from './inactive-tags-modal/inactive-tags-modal.component';
import { ManageSystemTagsPageComponent } from './manage-system-tags-page/manage-system-tags-page.component';
import { ManageTagsModalComponent } from './manage-tags-modal/manage-tags-modal.component';
import { ManageTagsComponent } from './manage-tags/manage-tags.component';
import { SystemTagComponent } from './system-tag/system-tag.component';
import { SystemTagsInputComponent } from './system-tags-input/system-tags-input.component';
import { TagColorPickerComponent } from './tag-color-picker/tag-color-picker.component';

@NgModule({
  imports: [GCCoreModule],
  declarations: [
    TagColorPickerComponent,
    SystemTagsInputComponent,
    ManageTagsComponent,
    ManageTagsModalComponent,
    ManageSystemTagsPageComponent,
    CreateSystemTagModalComponent,
    InactiveTagsModalComponent,
    SystemTagComponent,
    ImportTagsModalComponent
  ],
  exports: [
    ManageTagsComponent,
    SystemTagsInputComponent,
    ManageTagsModalComponent,
    ManageSystemTagsPageComponent,
    CreateSystemTagModalComponent,
    InactiveTagsModalComponent,
    SystemTagComponent
  ]
})
export class SystemTagsModule { }
